import styled from "styled-components";

function ReviewItem({title, content, writer}){
    return(
        <Container>
            <Title>{title}</Title>
            <Content>{content}</Content>
            <Writer>{writer}</Writer>
        </Container>
    )
}

const Container = styled.div`
    background-color: #FDFDFD;
    display: flex;
    flex-direction: column;
    padding: 30px;
    gap: 50px;
    flex-basis: 100%;
    border-radius: 20px;
    box-shadow: 0px 8px 8px 0px rgba(0, 121, 18, 0.12);
`

const Title = styled.div`
    color: #007912;
    font-size: 20px;
    font-weight: 700;
`

const Content = styled.div`
    color: #555;
    font-size: 16px;
    line-height: 160%;
    flex-grow: 1;
`

const Writer = styled.div`
    font-size: 18px;
    color: #555;
    text-align: right;
`

export default ReviewItem;